import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Label } from "@/components/ui/label";

/**
 * Reusable photo slot (upload / preview / remove) para itens, lançamentos FDP, etc.
 */
export default function PhotoSlot({ label, path, onPathChange, testid, compact = false }) {
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let obj;
    if (path) {
      api.get(`/files/${path}`, { responseType: "blob" })
        .then((r) => {
          obj = URL.createObjectURL(r.data);
          setPreview(obj);
        })
        .catch(() => setPreview(null));
    } else {
      setPreview(null);
    }
    return () => { if (obj) URL.revokeObjectURL(obj); };
  }, [path]);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onPathChange?.(r.data?.path || null);
    } catch (e) {
      console.error("upload err", e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-1.5">
      {label && <Label className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">{label}</Label>}
      <div className={`${compact ? "aspect-square" : "aspect-video"} rounded-lg border border-slate-200 bg-slate-50 overflow-hidden relative`}>
        {preview ? (
          <>
            <img src={preview} alt={label} className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={() => onPathChange?.(null)}
              data-testid={`${testid}-remove`}
              className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-[11px] shadow"
            >
              ×
            </button>
          </>
        ) : (
          <label
            className="w-full h-full flex flex-col items-center justify-center cursor-pointer text-[11px] text-slate-500 hover:bg-slate-100"
            data-testid={`${testid}-upload`}
          >
            {busy ? "Enviando..." : "+ Foto"}
            <input
              type="file"
              accept="image/*"
              className="hidden"
              disabled={busy}
              onChange={(e) => upload(e.target.files?.[0])}
            />
          </label>
        )}
      </div>
    </div>
  );
}
